<template>
<div class="page invoice">
  <h1>Facturatie</h1>
</div>
</template>

<script>
export default {
name: "Invoice"
}
</script>
